import { FeatureName, getUsageSuggestions } from 'owa-personalization';

// Personalization suggestions are retrieved in owa-mail-post-boot.
// If the user launches compose for the first time in their session, it's possible that the
// suggestions were not retrieved at the time we checked.
// The 'serviceLoaded' field indicates this scenario. We use it to ensure we don't send a signal
// to the Personalization service needlessly. We only want to send a signal if the service explicitly
// told us to show ghost text, and not when we are showing ghost text only because we haven't called the
// service yet.
export interface InitialHintState {
    showInitialHint: boolean;
    sendSignalToPersonalizationService: boolean;
}

export default function shouldShowInitialHint(): InitialHintState {
    const suggestions = getUsageSuggestions(FeatureName.Sonora);

    let showInitialHint = true;

    // If we don't get back any suggestions, just show the ghost text.
    suggestions?.forEach(suggestion => {
        if (suggestion.action === 'HideGhostText') {
            showInitialHint = false;
        }
    });

    return {
        showInitialHint: showInitialHint,
        sendSignalToPersonalizationService: !!suggestions,
    };
}
